module.exports = __webpack_public_path__ + "static/media/WonderWoman.7dbadfe6.png";